import { Component } from '@angular/core';
import { BlockBaseComponent } from "../block-base/block-base.component";
import { StoreSelectorsService } from "../../../../services/store-selectors.service";
import { MatDialog } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";

@Component({
    selector: 'app-block-knx',
    templateUrl: './block-knx.component.html',
    styleUrls: ['./block-knx.component.scss']
})
export class BlockKnxComponent extends BlockBaseComponent {
    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.ip', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "ip",
                storePath: 'Data[0].Knx[0].$.ip'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.receivedEvent', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "receivedEvent",
                storePath: 'Data[0].Knx[0].$.receivedEvent'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.sendEvent', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "sendEvent",
                storePath: 'Data[0].Knx[0].$.sendEvent'
            },
        ];
    }
}